{
  "access-denied-user": "L'utilisateur saisi ne peut pas accéder à ce site",
  "activation": "Activation",
  "code": "Code",
  "code-sent": "Code envoyé",
  "contact": "Contact",
  "enter": "Entrer",
  "error-text": "Erreur",
  "mail": "Courriel",
  "new-version-available": "Nouvelle version disponible",
  "password": "Mot de passe",
  "resend-wait": "Attendez {{seconds}}s pour renvoyer",
  "server-apologies": "Désolé pour le dérangement",
  "server-maintenance": "Serveur en maintenance",
  "translation-load-error": "Erreur lors du chargement des traductions",
  "user": "Utilisateur",
  "user-or-password-incorrect": "Utilisateur ou mot de passe incorrect",
  "wait": "Attendez s'il vous plaît"
}